import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { VesselSelectorComponent } from './vessel-selector/vessel-selector.component';

@Component({
  selector: 're-app-bar',
  templateUrl: './app-bar.component.html',
  styleUrl: './app-bar.component.css',
  imports: [UserMenuComponent, VesselSelectorComponent],
})
export class AppBarComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  appStore = inject(AppStore);
  authStore = inject(AuthStore);

  private navigationEnd$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event) => (event as NavigationEnd).urlAfterRedirects),
  );

  currentUrl = toSignal(this.navigationEnd$, {
    initialValue: this.router.url,
  });

  title = computed(() => {
    const currentUrl = this.currentUrl();
    const split = currentUrl.split('/').filter((s) => s);

    if (!split?.length) return '';

    if (split.length === 2) {
      switch (split[1]) {
        case 'crew-dashboard':
          return 'Crew Dashboard';
        default:
          return '';
      }
    }

    return '';
  });

  isMainLayout(): boolean {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data['layout'] === 'main';
  }
}
